/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UsageInputs */

const en_usage = /** @type {(inputs: UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage`)
};

const fr_usage = /** @type {(inputs: UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisation`)
};

const de_usage = /** @type {(inputs: UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwendung`)
};

const it_usage = /** @type {(inputs: UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizzo`)
};

const ru_usage = /** @type {(inputs: UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Использование`)
};

const es_usage = /** @type {(inputs: UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso`)
};

const zh_cn2_usage = /** @type {(inputs: UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用法`)
};

const ja_usage = /** @type {(inputs: UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用法`)
};

const hi_usage = /** @type {(inputs: UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रयोग`)
};

const pt_pt2_usage = /** @type {(inputs: UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso`)
};

/**
* | output |
* | --- |
* | "Usage" |
*
* @param {UsageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage = /** @type {((inputs?: UsageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UsageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage(inputs)
	if (locale === "de") return de_usage(inputs)
	if (locale === "it") return it_usage(inputs)
	if (locale === "ru") return ru_usage(inputs)
	if (locale === "es") return es_usage(inputs)
	if (locale === "zh-CN") return zh_cn2_usage(inputs)
	if (locale === "ja") return ja_usage(inputs)
	if (locale === "hi") return hi_usage(inputs)
	if (locale === "pt-PT") return pt_pt2_usage(inputs)
	return en_usage(inputs)
});